import React from 'react';
import { connect } from 'react-redux';
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@material-ui/core';
import Add from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import Delete from '@material-ui/icons/Delete';

import { setNewSOProducts } from 'redux/actions';

const PaymentDisplayTable = ({soProducts, setNewSOProducts, ...props}) => {

  const incrementQuantity = (productId, unitPrice) => {
    const index = soProducts.findIndex(soProduct => soProduct.productId === productId);

    setNewSOProducts([
      ...soProducts.slice(0, index),
      {
        ...soProducts[index],
        quantity: soProducts[index].quantity + 1
      },
      ...soProducts.slice(index + 1)
    ]);
    props.setCurrSubTotal(props.currSubTotal + unitPrice);
  };
  
  const decrementQuantity = (productId, unitPrice) => {
    const index = soProducts.findIndex(soProduct => soProduct.productId === productId);
    //if the product quantity is greater than 1, decrement it by 1.
    if (soProducts[index].quantity > 1) {
      setNewSOProducts([
        ...soProducts.slice(0, index),
        {
          ...soProducts[index],
          quantity: soProducts[index].quantity - 1
        },
        ...soProducts.slice(index + 1)
      ]);
    }
    //else remove the product from soProducts
    else setNewSOProducts(soProducts.filter(soProduct => soProduct.productId !== productId));
    props.setCurrSubTotal(props.currSubTotal - unitPrice);
  };

  const deleteProduct = (productId, unitPrice, quantity) => {
    setNewSOProducts(soProducts.filter(soProduct => soProduct.productId !== productId));
    props.setCurrSubTotal(props.currSubTotal - (unitPrice * quantity));
  };

  return (
    <TableContainer
      component={Paper}
      style={{
        height: 324,
        scrollbarWidth: 'thin',
        margin: '16px 0'
      }}
    >
      <Table>
        <TableBody>
          {soProducts.map((soProduct) => (
            <TableRow key={soProduct.productId}>
              <TableCell style={{ width: 130 }}>{soProduct.name}</TableCell>
              <TableCell>{soProduct.unitPrice}</TableCell>
              <TableCell>
                <IconButton
                  style={{ marginRight: 10 }}
                  onClick={decrementQuantity.bind(this, soProduct.productId, soProduct.unitPrice)}
                >
                  <Remove />
                </IconButton>
                <span style={{ margin: '0 10px' }}>{soProduct.quantity}</span>
                <IconButton
                  style={{ marginLeft: 10 }}
                  onClick={incrementQuantity.bind(this, soProduct.productId, soProduct.unitPrice)}
                >
                  <Add />
                </IconButton>
              </TableCell>
              <TableCell>
                <IconButton
                  onClick={deleteProduct.bind(this, soProduct.productId, soProduct.unitPrice, soProduct.quantity)}
                >
                  <Delete style={{color: "#FF0000"}}/>
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
};

export default connect (null, {setNewSOProducts}) (PaymentDisplayTable);